import { useTheme } from '../ThemeProvider';

import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

interface PersonIconProps {
    width?: number;
    height?: number;
    color?: string;
    testID?: string;
    accessibilityLabel?: string;
    accessible?: boolean;
}

export const PersonIcon = ({
    width = 48,
    height = 50,
    color,
    testID,
    accessibilityLabel,
    accessible,
}: PersonIconProps): React.JSX.Element => {
    const theme = useTheme();

    const viewBox = '0 0 48 50';
    const fillColor = color === undefined ? theme.colors.foregroundInverse : color;
    // Allow for manual turning off of accessible
    const accessibilityProps = {
        accessible,
        ...(accessibilityLabel ? { accessibilityLabel } : { accessible: false }),
    };

    return (
        <View testID={testID}>
            <Svg
                width={width}
                height={height}
                viewBox={viewBox}
                fill="none"
                preserveAspectRatio="xMidYMid meet"
                testID={`${testID}-svg`}
                {...accessibilityProps}
            >
                <Path
                    d="M24 24.9909C20.6067 24.9909 17.7088 23.7896 15.3064 21.3872C12.9039 18.9847 11.7027 16.0868 11.7027 12.6935C11.7027 9.30073 12.9039 6.40578 15.3064 4.00868C17.7088 1.61207 20.6067 0.413765 24 0.413765C27.3933 0.413765 30.2912 1.61207 32.6936 4.00868C35.0961 6.40578 36.2973 9.30073 36.2973 12.6935C36.2973 16.0868 35.0961 18.9847 32.6936 21.3872C30.2912 23.7896 27.3933 24.9909 24 24.9909ZM0 42.9303V40.7646C0 39.0014 0.455918 37.3784 1.36775 35.8956C2.2791 34.4127 3.49423 33.2822 5.01314 32.504C8.07143 30.9807 11.1843 29.8353 14.3519 29.0678C17.5189 28.3003 20.735 27.9165 24 27.9165C27.288 27.9165 30.5157 28.2973 33.6832 29.059C36.8508 29.8206 39.952 30.9631 42.9869 32.4864C44.5058 33.2646 45.7209 34.3923 46.6322 35.8692C47.5441 37.3467 48 38.9785 48 40.7646V42.9303C48 44.7725 47.3512 46.3424 46.0537 47.6399C44.7562 48.9375 43.1863 49.5862 41.3441 49.5862H6.6559C4.8137 49.5862 3.24384 48.9375 1.9463 47.6399C0.648767 46.3424 0 44.7725 0 42.9303Z"
                    fill={fillColor}
                />
            </Svg>
        </View>
    );
};
